<template>
    <div class="col-md-10 col-md-offset-1">
        <h2 class="title">Enregister un son</h2>
        <div class="form-group">
            <label>Texte :</label>
            <textarea class="form-control" v-model="text" rows="5" @change="clearTestVoiceFile()"></textarea>
        </div>
        <br>
        <voice-selection ref="voiceSelection" :text="text || 'Ceci est un test.'"></voice-selection>
        <br>
        <br>
        <div style="text-align: center">
            <button class="button btn btn-info" @click="generateVoice()" :disabled="!allowGeneration">Générer la voix</button>
        </div>
        <a ref="filePlaceholder" href="" download hidden></a>            
    </div>
</template>

<script>
import VoiceSelection from 'components/VoiceSelection';

export default {
    name: 'FreeGeneration',
    components: {
        VoiceSelection
    },                      
    data: function()    {
        return {
            text: ''
        };
    },                                                    
    computed: {
        allowGeneration() {
            return this.text && (this.$refs.voiceSelection ? !!this.$refs.voiceSelection.voiceOptions : false);
        }
    },   
    methods: {
        clearTestVoiceFile() {
            this.$refs.voiceSelection.clearTestVoiceFile();
        },
        generateVoice() {
            let self = this;
            this.$store.dispatch('textToSpeech', {
                textToSpeechData: Object.assign(this.$refs.voiceSelection.voiceOptions, {text: this.text}),
                callbacks: {
                    success(blobUrl) {
                        self.$store.commit('VOICE_PRESET_ADDED', Object.assign(self.$refs.voiceSelection.voiceOptions, {id: -1}));
                        self.$refs.filePlaceholder.href = blobUrl;
                        self.$refs.filePlaceholder.download = 'voice' + Date.now() + '.wav';
                        self.$refs.filePlaceholder.click();
                    }
                }
            });
        }
    },
    beforeCreate()  {
        this.$emit('navbarUpdate', {
            text: 'Retour',
            pathData: null
        });
    }
}
</script>

<style>
.title  {
    text-align:center;
    margin-bottom:2em;
}
</style>